import type { CommentSideValue } from '@/data/v2/pr/pending-comments-types';

import type { PrV2GithubReviewSide } from './types';

import { CommentSide } from '@/data/v2/pr/pending-comments-types';

export function commentSideToGithubReviewSide(side: CommentSideValue): PrV2GithubReviewSide {
  return side === CommentSide.old ? 'LEFT' : 'RIGHT';
}

export function githubReviewSideToCommentSide(side: PrV2GithubReviewSide): CommentSideValue {
  return side === 'LEFT' ? CommentSide.old : CommentSide.new;
}
